module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB6SURBVHgB7dbBCYAwDIXh6ASOUHAwZ3CDuoErOJjQEbpBTUFvydUI/t+pEAov7eWJAAAAAPirwRvMKS3SZNfjJLGKpsxnKYc1HL1brUmW+PBduh/S5C4wfCP8o3oDdwHdYG39++JVzbIJAAAGutAL6ELR6EIAAAAATBc7DSARfMHo9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-icon.png
// module id = 1598
// module chunks = 0